import Vue from 'vue'
import Antd from 'ant-design-vue'
import http from 'axios'
import Promise from 'bluebird'

import App from './App.vue'

import './styles/antd.less'
import './registerServiceWorker'

import router from './router'
import store from './store'
import socket from "./socket"

window.Promise = Promise;

Vue.config.productionTip = false

Vue.use(Antd)
Vue.prototype.$http = http
Vue.prototype.$socket = socket();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
